import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import style from './style';
import UiComponent from '../UiComponent';

export default class ColorPicker2 extends UiComponent {

  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      searchable: true,
      selectValue: '',
      clearable: true,
    };

    this.optionToColor = {};

    this.updateValue = this.updateValue.bind(this);
    this.buildOptions = this.buildOptions.bind(this);
    this.getColorById = this.getColorById.bind(this);
  }

  getColorById(id) {
    if (this.props.options[id]) {
      return this.props.options[id].color;
    } else {
      return '';
    }
  }

  componentWillMount(){
    this.updateValue({value: this.props.value})
  }

  updateValue(newValue) {
    this.setState({
      selectValue: newValue,
      color: this.getColorById(newValue.value),
    });

    this.props.field.value = newValue.value;

    this.props.onChange(this.props.field.name, this.props.field);
  }

  buildOptions(options) {
    const arrOptions = [];

    for (let key in options) {
      arrOptions.push({
        value: key,
        label: options[key].label,
      });
    }

    return arrOptions;
  }

  render() {
    if (this.state.color && this.state.color.length > 0) {
      style.color.backgroundColor = this.state.color;
    }
    return (
      <div className="row" style={{
        paddingBottom: '15px',
      }}>
        <div className="col col-md-12">
          {this.getLabel()}
        </div>
        <div className="col">
          <Select
            autosize={false}
            placeholder="Choose job card"
            options={this.buildOptions(this.props.options)}
            clearable={this.state.clearable}
            name="selected-state"
            disabled={this.state.disabled || this.props.disabled}
            value={this.props.value}
            onChange={this.updateValue}
          />
        </div>
        <div className="col" style={style.color}></div>
        <div className="col col-md-12">
          {this.getErrors()}
        </div>
      </div>
    );
  }
}

ColorPicker2.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/ColorPicker2/index.js